// extracted by mini-css-extract-plugin
export var active = "_lu-2";
export var recordingDot = "_lu-1";
export var recordingIndicator = "_lu-0";